
import { gender, title, flightStatus } from "./enum"
import config from "./config"
import moment from "moment"

export function stdFromJourneys(jnys) {
    if (!jnys.forEach || !jnys.length > 0) return null;
    let sorted = jnys.sort((a, b) => new Date(a.departureDate).getTime() - new Date(b.departureDate).getTime());
    return new Date(sorted[0].departureDate)
}

export function maxStdFromJourneys(jnys) {
    if (!jnys.forEach || !jnys.length > 0) return null;
    let sorted = jnys.sort((a, b) => new Date(a.departureDate).getTime() - new Date(b.departureDate).getTime());
    return new Date(sorted[sorted.length - 1].departureDate);
}

export function staFromJourneys(jnys) {
    if (!jnys.forEach || !jnys.length > 0) return null;
    let sorted = [...jnys].sort((a, b) => new Date(b.arrivalDate).getTime() - new Date(a.arrivalDate).getTime());
    return new Date(sorted[0].arrivalDate)
}

export function mapToken(token) {
    return {
        headers: {
            [config.AUTH_KEY]: `Bearer ${token}`
        }
    }
}

export function isChild(dob, datum = new Date()) {
    let tStart = moment(datum)
        .add(-2, "years")
        .toDate()
        .getTime();
    let tEnd = moment(datum)
        .add(-12, "years")
        .toDate()
        .getTime();
    let dobTime = moment(dob).toDate().getTime();
    return dobTime > tEnd && dobTime <= tStart;
}

export function isInfant(dob, datum = new Date()) {
    let tStart = moment(datum)
        .add(-7, "days")
        .toDate()
        .getTime();
    let tEnd = moment(datum)
        .add(-2, "years")
        .toDate()
        .getTime();
    let dobTime = moment(dob).toDate().getTime();
    return dobTime > tEnd && dobTime <= tStart;
}

export function isAdult(dob, datum = new Date()) {
    let ts = moment(datum)
        .add(-12, "years")
        .toDate()
        .getTime();
    let dobTime = moment(dob).toDate().getTime();
    return dobTime < ts;
}

export function getTitle(dob, genderType, datum = new Date()) {
    if (isAdult(dob, datum)) {
        return genderType == gender.male ? title.mr : title.ms;
    } else {
        return genderType == gender.male ? title.mstr : title.miss;
    }
}

export function getFinancialYears(force = false) {
    let now = new Date();
    let utc = now.getTime() + now.getTimezoneOffset() * 60000;
    let d = new Date(utc + 8 * 60 * 60000); // +8 時區
    let ts = d.getTime();
    let financialYears = [];
    let currentYear = d.getFullYear();
    const minDate = new Date(`${currentYear}-03-01T00:00:00+08:00`).getTime();
    const maxDate = new Date(`${currentYear}-03-31T23:59:59+08:00`).getTime();

    if (force) return [currentYear, currentYear - 1];

    if (ts < minDate) {
        financialYears = [currentYear - 1];
    } else if (
        ts >= minDate &&
        ts <= maxDate
    ) {
        financialYears = [currentYear, currentYear - 1];
    } else if (ts > maxDate) {
        financialYears = [currentYear];
    }
    return financialYears;
}

export function getSubPnrs(booking) {
    if (booking && booking.children && booking.children.forEach) {
        return booking.children.map(x => x.recordlocator);
    }
    return [];
}

export const getSegmentReference = jny => [jny.departureDate.substring(0, 10).replace(/-/g, ''), jny.flightNo, `${jny.origin}${jny.destination}`].join(' ');

export const getSegmentReferences = booking => booking.journeys.map(j => getSegmentReference(j));

export const getFullName = usr => {
    if (usr) {
        let title = usr.title?.toUpperCase();
        if (title) {
            if (title !== "MSTR" && title !== "MISS" && title !== "MASTER" && title !== "MISTER") {
                title = title?.trimRight(".") + ". "
            } else {
                title = title + ' ';
            }
        }
        return `${title}${getName(usr)}`
    }
    return "";
};

export const getName = usr => {
    if (usr) {
        if (usr.lastName) {
            return `${usr.lastName} ${usr.firstName}`
        } else if (usr.lastname) {
            return `${usr.lastname} ${usr.firstname}`
        }
    }
    return "";
};

export const transformBookings = (bookings, filter = false) => {
    const container = [];
    const transformed = (filter ? bookings.filter(b => b.journeys && b.journeys.length > 0) : bookings).map(x => {
        if (x.children && x.children.forEach && x.children.length > 0) {
            x.children.forEach(y => {
                y.parentPnr = x.recordlocator;
                container.push(y);
            });
            x.children = x.children.map(y => y.recordlocator)
        }
        return x;
    })
    const result = [...transformed, ...container].map(b => {
        b.std = stdFromJourneys(b.journeys)?.getTime();
        b.maxStd = maxStdFromJourneys(b.journeys)?.getTime();
        b.sta = staFromJourneys(b.journeys)?.getTime();
        // cancelled, refund required.
        if (b.journeys.length === 0 && b.flightStatus == flightStatus.cancelled) {
            b.cancelled = true;
            // cancelled, refund required.
            b.refunded = b.passengers.length > 0 && (b.passengers.length === b.passengers.filter(x => x.refund !== undefined && x.refund === 0).length)
            b.refundRequired = b.passengers.find(x => x.refund !== undefined && x.refund !== 0);
        }
        return b
    });

    return result;
}

export const get30YearDate = d => {
    return moment(d)
        .add(1, 'day')
        .add(-30, "years");
}